var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-chat",staticStyle:{"display":"none"},attrs:{"data-properties":JSON.stringify(_vm.fields.chatConfiguration)}},[_c('p',[_vm._v("live chat")]),_c('button',{on:{"click":_vm.startChat}},[_vm._v("start chat")])])}
var staticRenderFns = []

export { render, staticRenderFns }